import { render } from "./Search.svg?vue&type=template&id=595d26a6"
const script = {}
script.render = render

export default script